import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiGetFreeeAccountItemsRequest,
  DefaultApiGetFreeeItemsRequest,
  DefaultApiGetFreeeMemoTagsRequest,
  DefaultApiGetFreeeSectionsRequest,
  DefaultApiGetFreeeSegmentTagsRequest,
  DefaultApiGetFreeeTaxesRequest,
  UpdateCardAccountUnitRequest,
  DefaultApiGetFreeePartnersRequest,
  DefaultApiUpdateFreeeConnectRequest,
  DefaultApiUpdateFreeeSelectCompanyRequest,
  DefaultApiGetFreeeCompaniesRequest,
  DefaultApiGenerateFreeeRedirectUrlRequest,
  DefaultApiUpdateFreeeJournalingRequest,
  DefaultApiDeleteFreeeConnectedRequest,
  DefaultApiPostFreeeAccountForPointsRequest,
  DefaultApiPutFreeeEndJournalEntryTransitionModeRequest,
  DefaultApiGetFreeeSyncStatusRequest,
  DefaultApiGetFreeeConnectedUserRequest,
  DefaultApiDeleteFreeeEndJournalEntryTransitionModeRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const deleteFreeeConnected = async (
  instance: AxiosInstance,
  params: DefaultApiDeleteFreeeConnectedRequest
) => {
  return await userApiDefaultApiFactory(instance).deleteFreeeConnected(params)
}

export const getFreeeAccountItems = async (
  instance: AxiosInstance,
  params: DefaultApiGetFreeeAccountItemsRequest
) => {
  return await userApiDefaultApiFactory(instance).getFreeeAccountItems(params)
}

export const getFreeeConnected = async (
  instance: AxiosInstance,
  organizationId: string
) => {
  return await userApiDefaultApiFactory(instance).getFreeeConnected({
    organizationId,
  })
}

export const getFreeeItems = async (
  instance: AxiosInstance,
  params: DefaultApiGetFreeeItemsRequest
) => {
  return await userApiDefaultApiFactory(instance).getFreeeItems(params)
}

export const getFreeeMemoTags = async (
  instance: AxiosInstance,
  params: DefaultApiGetFreeeMemoTagsRequest
) => {
  return await userApiDefaultApiFactory(instance).getFreeeMemoTags(params)
}

export const getFreeeSections = async (
  instance: AxiosInstance,
  params: DefaultApiGetFreeeSectionsRequest
) => {
  return await userApiDefaultApiFactory(instance).getFreeeSections(params)
}

export const getFreeeSegmentTags = async (
  instance: AxiosInstance,
  params: DefaultApiGetFreeeSegmentTagsRequest
) => {
  return await userApiDefaultApiFactory(instance).getFreeeSegmentTags(params)
}

export const getFreeeTaxes = async (
  instance: AxiosInstance,
  params: DefaultApiGetFreeeTaxesRequest
) => {
  return await userApiDefaultApiFactory(instance).getFreeeTaxes(params)
}

export const updateCardAccountUnit = async (
  instance: AxiosInstance,
  organizationId: string,
  updateCardAccountUnitRequest: UpdateCardAccountUnitRequest
) => {
  return await userApiDefaultApiFactory(instance).updateCardAccountUnit({
    organizationId,
    updateCardAccountUnitRequest,
  })
}

export const getFreeePartners = async (
  instance: AxiosInstance,
  params: DefaultApiGetFreeePartnersRequest
) => {
  return await userApiDefaultApiFactory(instance).getFreeePartners(params)
}

export const updateFreeeConnect = async (
  instance: AxiosInstance,
  params: DefaultApiUpdateFreeeConnectRequest
) => {
  return await userApiDefaultApiFactory(instance).updateFreeeConnect(params)
}

export const updateFreeeSelectCompany = async (
  instance: AxiosInstance,
  params: DefaultApiUpdateFreeeSelectCompanyRequest
) => {
  return await userApiDefaultApiFactory(instance).updateFreeeSelectCompany(
    params
  )
}

export const getFreeeCompanies = async (
  instance: AxiosInstance,
  params: DefaultApiGetFreeeCompaniesRequest
) => {
  return await userApiDefaultApiFactory(instance).getFreeeCompanies(params)
}

export const generateFreeeRedirectUrl = async (
  instance: AxiosInstance,
  params: DefaultApiGenerateFreeeRedirectUrlRequest
) => {
  return await userApiDefaultApiFactory(instance).generateFreeeRedirectUrl(
    params
  )
}

export const updateFreeeJournaling = async (
  instance: AxiosInstance,
  params: DefaultApiUpdateFreeeJournalingRequest
) => {
  return await userApiDefaultApiFactory(instance).updateFreeeJournaling(params)
}

export const createFreeeAccountForPoints = async (
  instance: AxiosInstance,
  params: DefaultApiPostFreeeAccountForPointsRequest
) => {
  return await userApiDefaultApiFactory(instance).postFreeeAccountForPoints(
    params
  )
}

export const updateFreeeEndJournalEntryTransitionMode = async (
  instance: AxiosInstance,
  params: DefaultApiPutFreeeEndJournalEntryTransitionModeRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).putFreeeEndJournalEntryTransitionMode(params)
}

export const getFreeeSyncStatus = async (
  instance: AxiosInstance,
  params: DefaultApiGetFreeeSyncStatusRequest
) => {
  return await userApiDefaultApiFactory(instance).getFreeeSyncStatus(params)
}

export const getFreeeConnectedUser = async (
  instance: AxiosInstance,
  params: DefaultApiGetFreeeConnectedUserRequest
) => {
  return await userApiDefaultApiFactory(instance).getFreeeConnectedUser(params)
}

export const deleteFreeeEndJournalEntryTransitionMode = async (
  instance: AxiosInstance,
  params: DefaultApiDeleteFreeeEndJournalEntryTransitionModeRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).deleteFreeeEndJournalEntryTransitionMode(params)
}

// Do Not Remove this line ===@import api client===
